<template>
  <ColescbaApp :app-routes="routes" app-container-classes="container mx-auto w-full">
    <div v-if="$route.meta.header" class="mx-auto mb-2 max-w-9xl space-y-6" slot="before-router">
      <div class="mt-4">
        <h4 class="text-center text-2xl font-semibold text-gray-700 md:text-3xl">
          {{ $route.meta.header.text }}
        </h4>
      </div>
    </div>
  </ColescbaApp>
</template>

<script>
import { useColescba, useProvideService } from '@colescba/app-vue'
import { Facade } from '@/services/facade.service'
import { NominaNotarialFederalService } from '@colescba/services'
import { ReportesService } from './services/reporte.service'
import { GestorArchivosService } from '@colescba/services'
import { FirmaDigitalService } from './services/firma-digital.service'

const requestedServices = [
  config =>
    useProvideService(
      { baseURL: config.VUE_APP_MIGRACIONES_SERVICE_URL, ...config },
      'api',
      Facade,
    ),

  config =>
    useProvideService(
      { baseURL: config.VUE_APP_NOMINA_NOTARIAL_FEDERAL_SERVICE_URL, ...config },
      'nominaNotarialFederal',
      NominaNotarialFederalService,
    ),
  config =>
    useProvideService(
      { baseURL: config.VUE_APP_REPORTES_SERVICE_URL, ...config },
      'reporteService',
      ReportesService,
    ),
  config =>
    useProvideService(
      { baseURL: config.VUE_APP_GESTOR_ARCHIVOS_SERVICE_URL, ...config },
      'gestorArchivos',
      GestorArchivosService,
    ),
  config =>
    useProvideService(
      { baseURL: config.VUE_APP_FIRMADIGITAL_SERVICE_URL, ...config },
      'firmaDigital',
      FirmaDigitalService,
    ),
]

import { routes } from '@/config'

export default {
  mixins: [useColescba({ env: process.env, requestedServices })],

  data() {
    return {
      routes,
    }
  },
}
</script>
